import { useMutation } from '@tanstack/react-query';
import { loaders } from './files.loaders';

export const useUploadFile = () => {
  const mutation = useMutation(loaders.uploadFile);

  return mutation;
};
